import type { Ref } from "vue";
import LxcError from "~/core/models/LxcError.class";
import type { Firmware } from "~/modules/firmware/models/Firmware.interface";
import firmwareService from "~/modules/firmware/services/firmware.service";

export function useUploadFirmware({
  businessUnitCode,
}: {
  businessUnitCode: number;
}) {
  const error: Ref<LxcError | null | undefined> = ref(null);
  const isLoading = ref(false);
  const result: Ref<Firmware | undefined> = ref(undefined);

  async function uploadFirmware(
    firmwareFile: File,
    progress: Ref<number | undefined | null>,
  ) {
    isLoading.value = true;
    error.value = undefined;

    const response = await firmwareService.uploadBusinessUnitFirmware(
      businessUnitCode,
      firmwareFile,
      progress,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    uploadFirmware,
    error,
    isLoading,
    result,
  };
}
